export enum PaymentTypeEnum {
  PAYMENT = 'PAYMENT',
  BANK_IMPRINT = 'BANK_IMPRINT',
  REFUND = 'REFUND'
}

export const paymentTypeEnumMapping: Record<PaymentTypeEnum, { label: string; name: string }> = {
  [PaymentTypeEnum.PAYMENT]: {
    label: 'Paiement',
    name: 'paiement'
  },
  [PaymentTypeEnum.BANK_IMPRINT]: {
    label: 'Empreinte bancaire',
    name: 'pre-auth'
  },
  [PaymentTypeEnum.REFUND]: {
    label: 'Remboursement',
    name: 'remboursement'
  }
}
